import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageService, SessionStorageService } from 'angular-web-storage';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../environments/environment';
import { SP_APP_TYPE } from '../app.constants';

@Component({
  selector: 'app-appsources',
  templateUrl: './appsources.component.html',
  styleUrls: ['./appsources.component.scss']
})
export class AppsourcesComponent implements OnInit {

  sourceList: any;
  accessPrivileges: string;
  appName: string;

  constructor(
    private _appService: AppService,
    private _route: ActivatedRoute,
    private sessionStorage: SessionStorageService,
    private localStorage: LocalStorageService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {

    this.spinner.show();

    if (this.sessionStorage.get('accessPrivileges')) {
      this.accessPrivileges = this.sessionStorage.get('accessPrivileges');
    } else {
      this.accessPrivileges = environment.appPrivilege;
    }

    this._appService.getConfigDataByPage('all').subscribe(res => {
      this.appName = res['config_app_name']['config_val'];
    });

    this._appService.getAppsByType(SP_APP_TYPE).subscribe(res => {
      this.sourceList = res;
      this.spinner.hide();
    });

  }

}
